import styled from 'styled-components';

export default styled.div`
 .btn-add-container {
        display: flex;
        justify-content: flex-start;
        padding: 10px;
    }
`;
